export default class PoiMaps {
    constructor(googleInstance) {
        this.instance = googleInstance.maps;
        this.infoWindow = null;
        this.markers = [];
    }

    initMap($container, options) {
        this.map = new this.instance.Map($container, options);

        this.createInfoWindow();
    }

    /**
     * Function taken from old version of treasurybond page with small refactor
     */
    getBounds() {
        const helpRound = (m, val) => {
            return Math.round(val * m);
        }

        const helpGetCeil = (n, m, val) => {
            return n * Math.ceil(val * m);
        }

        const helpGetFloor = (n, m, val) => {
            return n * Math.floor(val * m);
        }
        const rawBounds = this.map.getBounds()
        const n = 0.1;
        const m = 10;
        const xMin = helpRound(m, helpGetFloor(n, m, rawBounds.getSouthWest().lng()));
        const xMax = helpRound(m, helpGetCeil(n, m, rawBounds.getNorthEast().lng()));
        const yMin = helpRound(m, helpGetFloor(n, m, rawBounds.getSouthWest().lat()));
        const yMax = helpRound(m, helpGetCeil(n, m, rawBounds.getNorthEast().lat()));
        const bounds = [yMin, yMax, xMin, xMax];
        const boundsFull = [];

        for (var x = 1; xMin + x <= xMax; x += 1) {
            for (var y = 1; yMin + y <= yMax; y += 1) {
                boundsFull.push(
                    parseInt(yMin + y - 1, 10) + ',' + parseInt(xMin + x - 1, 10) +
                    ',' + parseInt(yMin + y, 10) + ',' + parseInt(xMin + x, 10)
                );
            }
        }

        return {
            raw: rawBounds,
            simple: bounds,
            full: boundsFull
        };
    }

    /**
     * check if coords is visible on map
     */
    checkIfLatLngIsOnMap(lat, lng) {
        return this.map.getBounds().contains(new this.instance.LatLng(lat, lng));
    }

    /**
     * Getting image for markes based on data type
     */
    getMarkerIcon(iconName = '', size = []) {
        const iconNames = {
            makler: 'marker-navy.svg',
            facility: 'marker-red.svg',
        };
        const path = document.body.getAttribute('data-static');
        const iconImage = path + 'img/' + iconNames[iconName];

        return {
            url: iconImage,
            scaledSize: new this.instance.Size(...size),
        };
    }

    createMarker(data) {
        const { name, contact, address, opening_hours, lat, lng, type } = data;
        const marker = new this.instance.Marker({
            map: this.map,
            position: new this.instance.LatLng(lat, lng)
        });

        marker.setIcon(this.getMarkerIcon(type, [27, 37]));

        marker.addListener('click', () => {
            this.infoWindow.setContent(`
                <div class="gmaps__window-content">
                    <p><strong>${name}</strong></p>
                    <p>${address}</p>
                    <p>${contact}</p>
                    <p>${opening_hours}</p>
                </div>
            `);

            this.map.setCenter(marker.getPosition());
            this.infoWindow.open(this.map, marker);
        });

        this.markers.push(marker);
    }

    createInfoWindow() {
        this.infoWindow = new this.instance.InfoWindow({
            content: '',
            pixelOffset: new google.maps.Size(0, 0),
        });

        // po zalaodowaniu okienka dodaj odpowiednie style nadpisujące domyślne, googlowskie
        this.instance.event.addListener(this.infoWindow, 'domready', () => {
            document.body.querySelector('.gm-style-iw-a').classList.add('gmaps__window');
        });

        this.instance.event.addListener(this.infoWindow, 'closeclick', () => {
            this.infoWindow.close();
        });
    }

    sortDataByDistance(data = [], userLatLng) {
        const sorted = [];
        const result = [];

        for (let i = 0; i < data.length; i++) {
            const item = data[i];
            const itemCoords = new window.google.maps.LatLng(item.lat, item.lng);
            let d = window.google.maps.geometry.spherical.computeDistanceBetween(itemCoords, userLatLng); // distance between points

            sorted[i] = [i, d, item];
        }

        sorted.sort(function(a, b) {
            return a[1] - b[1];
        });

        for (let i = 0; i < sorted.length; i++) {
            result[i] = sorted[i][2];
        }

        return result;
    }

    /**
     * add every marker added to this.markers to the map
     */
    addMarkersToMap() {
        this.markers.forEach((marker) => marker.setMap(this.map));
    }

    /**
     * clear marker visible on map and reset previously added
     */
    clearMarkers() {
        this.markers.forEach((marker) => marker.setMap(null));
        this.markers = [];
    }
}


// WEBPACK FOOTER //
// ./front/treasurybond/js/components/poi/poi-maps.js